/* eslint-disable @typescript-eslint/no-explicit-any */
import PhoneInput from 'react-phone-number-input';
import { forwardRef } from 'react';

import 'react-phone-number-input/style.css';

import styles from './styles.module.scss';
import { useAppContext } from 'providers/AppProvider';

interface PhoneNumberInputProps {
  unicode?: string;
  placeholder?: string;
  isInvalid?: any;
  field?: any;
}

const PhoneNumberInput = forwardRef<HTMLInputElement, PhoneNumberInputProps>(
  ({ unicode, placeholder, field, isInvalid }, ref) => {
    const {
      config: { theme }
    } = useAppContext();
    return (
      <PhoneInput
        {...field}
        ref={ref}
        international
        defaultCountry={unicode}
        placeholder={placeholder}
        /* prettier-ignore */
        className={
          `${theme === 'dark' ? styles.phoneInputDark : styles.phoneInput} ${isInvalid ? styles.invalid : ''}`
        }
      />
    );
  }
);

export default PhoneNumberInput;
